import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.scss";

import Landingpageapp from "./components/Landingpageapp";

const Root = () => {
  document.querySelector("body").classList.add("app", "sidebar-mini", "ltr", "landing-page", "horizontalmenu");
  document.querySelector("body").classList.remove("main-body", "leftmenu");

  return (
    <BrowserRouter>
      <Landingpageapp />
    </BrowserRouter>
  );
};
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Root />);




